/* Cassaforte · cosa di un wallet personale arriva al browser, e quando.
 *
 * La regola che questo file fa rispettare: l'elenco NON chiede i segreti.
 * `GET /personal-wallets` restituisce `privateKey` e `mnemonic` (cifrati dal
 * browser, ma pur sempre il materiale da cui si risale a un wallet) e il CRUD
 * non ha `@Exclude()`. Chiedere `fields=id,name,createdAt` fa si' che sulla
 * schermata che si apre per prima, e che resta aperta, quei campi non
 * viaggino affatto: si scaricano solo quando si apre UN wallet, cioe' quando
 * l'utente ha appena digitato la password per vederlo.
 *
 * E' la stessa scelta fatta sulla schermata Wallet con
 * `CAMPI_WALLET_PUBBLICI`, per la stessa ragione.
 */

import type { ParametriCrud } from '../../api/client';
import type { PersonalWallet } from '../../api/tipi';

/** I soli campi che l'elenco ha bisogno di conoscere. Un componente che
 *  riceve una `VoceCassaforte` non PUO' stampare un segreto: non ce l'ha. */
export interface VoceCassaforte {
  id: number;
  nome: string;
  creatoIl: string | null;
}

export const CAMPI_ELENCO: ParametriCrud = {
  fields: ['id', 'name', 'createdAt'],
  sort: ['id,ASC'],
};

export function soloAnagrafica(w: PersonalWallet): VoceCassaforte {
  return { id: w.id, nome: w.name, creatoIl: w.createdAt ?? null };
}

/**
 * Copia negli appunti.
 *
 * Passa dal valore in memoria, non da una selezione nel DOM: cosi' si puo'
 * copiare una chiave che resta mascherata a schermo, che e' il caso normale
 * (la si incolla altrove, non la si legge). Nessun `console.error` nel ramo
 * di errore: il valore non deve finire in un log nemmeno per sbaglio.
 */
export async function copiaNegliAppunti(valore: string): Promise<boolean> {
  if (!valore || !navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(valore);
    return true;
  } catch {
    return false;
  }
}

/**
 * Forma mascherata di un segreto: abbastanza per riconoscere di aver aperto
 * la riga giusta, non abbastanza per trascriverlo da uno screenshot o da una
 * spalla. E' la forma predefinita a schermo; mostrarlo per intero e' un gesto
 * esplicito.
 */
export function mascherato(valore: string): string {
  if (!valore) return '';
  /* Nessuna coda in chiaro, nemmeno di quattro caratteri: sulla frase
     mnemonica sarebbero le ultime lettere dell'ultima parola, cioè un pezzo di
     segreto regalato a chi guarda lo schermo. Per riconoscere la riga bastano
     l'etichetta e il nome del wallet; per leggere il valore c'è «Mostra», che
     è un gesto deliberato. */
  return '•'.repeat(24);
}
